import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, ArrowLeft } from "lucide-react";
import { api, eur } from "@/lib/api";
import { BRAND } from "@/lib/brand";

const Shell = ({ children }) => (
  <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4">
    <div className="max-w-md w-full rounded-2xl border border-[#E2DDD5] bg-white p-8 text-center shadow-sm" data-testid="payment-result">{children}</div>
  </div>
);

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [st, setSt] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid) return;
    let stop = false;
    const poll = async () => {
      try { const { data } = await api.get(`/payments/status/${sid}`); if (stop) return; setSt(data); if (data.payment_status === "paid" || data.payment_status === "failed" || data.payment_status === "expired") return; }
      catch { /* retry */ }
      if (tries < 10) setTimeout(() => setTries((t) => t + 1), 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sid, tries]);
  const paid = st.payment_status === "paid";
  return (
    <Shell>
      {paid ? <CheckCircle2 className="h-14 w-14 text-emerald-600 mx-auto" /> : st.payment_status === "pending" ? <Loader2 className="h-14 w-14 text-[#0D3B52] mx-auto animate-spin" /> : <XCircle className="h-14 w-14 text-rose-600 mx-auto" />}
      <h1 className="font-display text-3xl text-[#0D3B52] mt-4" data-testid="payment-title">{paid ? "Pagamento ricevuto" : st.payment_status === "pending" ? "Verifica del pagamento…" : "Pagamento non completato"}</h1>
      <p className="text-[#5C6B73] mt-2 text-sm">
        {paid ? <>Grazie. Abbiamo registrato il pagamento{st.amount ? ` di ${eur(st.amount)}` : ""}{st.klarna ? " tramite Klarna" : ""}. Riceverà conferma anche da Stripe.</> :
          st.payment_status === "pending" ? "Attenda qualche secondo, stiamo confermando la transazione con Stripe." : "Il pagamento non risulta andato a buon fine. Può riprovare o contattarci."}
      </p>
      <div className="mt-6 flex flex-col gap-2">
        <Link to="/" className="inline-flex items-center justify-center rounded-full bg-[#0D3B52] text-white h-10 px-5 text-sm" data-testid="payment-home"><ArrowLeft className="h-4 w-4 mr-2" />Torna al sito</Link>
        <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="text-sm text-[#997316]">Serve aiuto? {BRAND.phone}</a>
      </div>
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell>
      <XCircle className="h-14 w-14 text-amber-500 mx-auto" />
      <h1 className="font-display text-3xl text-[#0D3B52] mt-4" data-testid="payment-title">Pagamento annullato</h1>
      <p className="text-[#5C6B73] mt-2 text-sm">Nessun addebito è stato effettuato. Può riprovare quando desidera.</p>
      <Link to="/" className="mt-6 inline-flex items-center justify-center rounded-full bg-[#0D3B52] text-white h-10 px-5 text-sm" data-testid="payment-home"><ArrowLeft className="h-4 w-4 mr-2" />Torna al sito</Link>
    </Shell>
  );
}
